export default "__VITE_ASSET__8Gw6Ycvr__"